import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import LoadingSpinner from '../components/LoadingSpinner.jsx';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleOAuthCallback } = useAuth();

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');
    const expiresIn = searchParams.get('expires_in');

    // Clear tokens from URL immediately
    window.history.replaceState({}, '', '/auth/callback');

    if (!accessToken || !refreshToken || !expiresIn) {
      navigate('/login');
      return;
    }

    handleOAuthCallback(accessToken, refreshToken, expiresIn)
      .then(() => {
        navigate('/dashboard');
      })
      .catch(() => {
        navigate('/login');
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <LoadingSpinner message="Signing you in..." />;
}
